import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/SupplierWallet`;


const ApiWallet = {

  getSupplierWalletByUserId: (params) => {
    const url = `${baseServiceUrl}/getSupplierWalletByUserId`;
    return ServiceApi.get(url);

  },

};

export default ApiWallet;


